import { Icon } from '../atoms/Icon';

const CARDS = [
  {
    icon: <Icon.spark size={18} color="#FFC2B5"/>,
    tone: 'orange',
    tag: 'Creators',
    title: 'Try any model, instantly',
    body: 'Access every frontier model — Flux, Veo 3, Kling, GPT Image, and more. One balance. One tab. No switching between 10 different tools.',
    cta: 'Open Zen',
    href: '/zen',
  },
  {
    icon: <Icon.code size={18} color="#A5B4FC"/>,
    tone: 'indigo',
    tag: 'Developers',
    title: 'Production-grade AI API',
    body: 'Unified REST API for image, video, and LLM generation. OpenAI-compatible. Per-output pricing. Used by enterprises in production today.',
    cta: 'API reference',
    href: '#api',
  },
  {
    icon: <Icon.diamond size={16} color="#C4B5FD"/>,
    tone: 'purple',
    tag: 'Agencies & Brands',
    title: 'Brand DNA',
    pill: 'Coming soon',
    body: 'Feed your brand guidelines, assets, and voice once. Every generation that follows looks like you. Built for marketing teams.',
    cta: 'Join waitlist',
    href: '#waitlist',
  },
];

const TONES = {
  orange: { glow: 'radial-gradient(circle at 0% 0%, rgba(255,77,141,.20), transparent 60%)',  ring: 'rgba(255,126,103,.35)', cta: '#FFAE9A' },
  indigo: { glow: 'radial-gradient(circle at 0% 0%, rgba(99,102,241,.22), transparent 60%)',   ring: 'rgba(129,140,248,.4)',  cta: '#A5B4FC' },
  purple: { glow: 'radial-gradient(circle at 0% 0%, rgba(167,139,250,.20), transparent 60%)',  ring: 'rgba(167,139,250,.35)', cta: '#C4B5FD' },
};

export default function UseCases() {
  return (
    <section id="usecases">
      <div className="container">
        <div className="eyebrow" style={{ marginBottom: 14 }}>What URO is for</div>
        <h2 className="h2" style={{ maxWidth: '20ch' }}>
          Built for creators, developers,<br/>and agencies.
        </h2>

        <div className="usecases-grid" style={{ marginTop: 56, display: 'grid', gap: 20, gridTemplateColumns: 'repeat(3, minmax(0,1fr))' }}>
          {CARDS.map((c, i) => {
            const tn = TONES[c.tone];
            return (
              <article key={i} className="card" style={{
                padding: 28, position: 'relative', overflow: 'hidden',
                display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 320,
              }}>
                <div style={{ position: 'absolute', inset: 0, background: tn.glow, pointerEvents: 'none' }}/>
                {c.pill && (
                  <span className="chip" style={{ position: 'absolute', top: 18, right: 18, background: 'rgba(167,139,250,.12)', borderColor: 'rgba(167,139,250,.25)', color: '#C4B5FD' }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#A78BFA' }}/>
                    {c.pill}
                  </span>
                )}
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ width: 44, height: 44, borderRadius: 12, display: 'grid', placeItems: 'center', background: 'rgba(255,255,255,.05)', border: `1px solid ${tn.ring}`, marginBottom: 22 }}>
                    {c.icon}
                  </div>
                  <div className="eyebrow" style={{ color: tn.cta, marginBottom: 10 }}>{c.tag}</div>
                  <h3 className="h3" style={{ marginBottom: 12 }}>{c.title}</h3>
                  <p style={{ color: 'var(--text-3)', fontSize: 15, lineHeight: 1.55, margin: 0 }}>{c.body}</p>
                </div>
                <a href={c.href} style={{ marginTop: 28, color: tn.cta, fontSize: 14, fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, position: 'relative', zIndex: 1 }}>
                  {c.cta} <Icon.arrow/>
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
